import { ApiGenericResponse } from "../ApiGenericResponse";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";

const ENDPOINT = "/device/folder/data";

export class EditFolderDataCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";

    params: EditFolderDataReqData = null;

    constructor(reqData: EditFolderDataReqData) {
        super();
        this.params = reqData;
    }

    public async execute(): Promise<ApiGenericResponse> {
        var res = await this.executeCommand(this.params);
        return new ApiGenericResponse(res);
    }
}

export class EditFolderDataReqData {
    constructor(public folderId: number, public converterType: string, public roleTitle: string, public folderData: string) {}
}
